import { apiBaseURL } from "@utils/apiHelpers";
import * as request from "superagent";

const TRANSFER_CHECK = `${apiBaseURL("v2")}/account/transfer/check/`;
const COMPLETE_TRANSFER = `${apiBaseURL("v2")}/account/transfer/complete/`;

export const apiAcceptTransfer = async (jwtToken) => {
  const {
    body: { data },
  } = await request
    .get(TRANSFER_CHECK)
    .type("json")
    .set("Authorization", `TokenBearer ${jwtToken}`);
  return data;
};

export const apiCompleteTransfer = async (
  jwtToken: string,
  payment_method_id: string,
  postal_code: string
) => {
  const result = await request
    .put(COMPLETE_TRANSFER)
    .set("Accept", "application/json")
    .set("Authorization", `TokenBearer ${jwtToken}`)
    .send({ payment_method_id, postal_code });
  return result;
};
